// extracted by mini-css-extract-plugin
module.exports = {"styles":"_-7nwmyGG6u6l2d6IFuHvP"};